import { render, staticRenderFns } from "./routes-item.vue?vue&type=template&id=440116d9"
import script from "./routes-item.vue?vue&type=script&lang=js"
export * from "./routes-item.vue?vue&type=script&lang=js"
import style0 from "./routes-item.vue?vue&type=style&index=0&id=440116d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports